import Auth from '@/helpers/auth'
import Dashboard from '@/pages/dashboard'
import Certificate from '@/pages/certificate'
import Courses from '@/pages/courses'
import MyCourses from '@/pages/my-courses'
import Proof from '@/pages/proof'

export const navigation = [
  {
    path: '/dashboard',
    name: 'Inicio',
    component: Dashboard,
    icon: 'fa-dashboard',
    beforeEnter: Auth.requireAuth
  },
  {
    name: 'Cursos',
    icon: 'fa-graduation-cap',
    children: [
      {
        path: '/me/certificate',
        name: 'Certificados',
        component: Certificate,
        beforeEnter: Auth.requireAuth
      },
      {
        path: '/me/proof',
        name: 'Constancia',
        component: Proof,
        beforeEnter: Auth.requireAuth,
        new: true
      },
      {
        path: '/me/courses/',
        name: 'Mis Cursos',
        component: MyCourses,
        beforeEnter: Auth.requireAuth
      },
      {
        path: '/courses',
        name: 'Todos los cursos',
        component: Courses,
        beforeEnter: Auth.requireAuth
      }
    ]
  }
]

function route (item) {
  let place = {
    path: item.path,
    name: item.name,
    component: item.component
  }
  if (item.beforeEnter) {
    place['beforeEnter'] = item.beforeEnter
  }
  return place
}

const menu = (function () {
  let routes = []
  for (var index in navigation) {
    if (navigation[index].children && navigation[index].children.length > 0) {
      for (var _index in navigation[index].children) {
        routes.push(route(navigation[index].children[_index]))
      }
    } else {
      routes.push(route(navigation[index]))
    }
  }
  return routes
})()

export default menu



// WEBPACK FOOTER //
// ./src/router/menu.js